import React, { useState, useEffect, useContext } from "react";
import moment from "moment";

import { useSnackbar } from "notistack";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Select,
  TextField,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";

import Pagination from "../../pagination";
import useStyles from "./useStyles";
import tableStyles from "./tableStyles";

import {
  getAll,
  getPage,
} from "../../../../services/formulario/FormularioService";

import ExcluirFormulario from "../excluir";
import { AppContext } from "../../context";
import TipoPerfil from "../../../../constants/tipoPerfil";

const FormulariosList = (props) => {
  const {
    history,
    marginTop = 0,
    mostrarColunaMenuAcoes = true,
    mostrarColunaSelecionar = false,
    mostrarSomenteAtivos = true,
    formularioVinculoSelecionado = null,
    onSetFormularioSelecionado = null,
  } = props;
  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles({ marginTop });
  const tableClasses = tableStyles();

  const { role } = useContext(AppContext);

  const [formularios, setFormularios] = useState([]);
  const [formularioDatas, setFormularioDatas] = useState([]);
  const [formularioSelecionado, setFormularioSelecionado] = useState([]);
  const [anchorElement, setAnchorElement] = useState(null);
  const [openExcluir, setOpenExcluir] = useState(false);

  const paginacaoInitialState = {
    page: 0,
    linesPerPage: 5,
    totalPages: 0,
  };

  const [paginacao, setPaginacao] = useState(paginacaoInitialState);

  const ordenacaoInitialState = {
    orderBy: "nomeFormulario",
    direction: "ASC",
  };

  const [ordenacao, setOrdenacao] = useState(ordenacaoInitialState);

  const filtroInitialState = {
    nomeFormulario: "",
    ativo: " ",
    dataMesAno: " ",
  };

  const [filtro, setFiltro] = useState(filtroInitialState);

  const isMenuOpen = Boolean(anchorElement) && mostrarColunaMenuAcoes;

  const formatDate = (stringTimestamp) => {
    let data = moment(stringTimestamp, "YYYY-MM-DDTHH:mm:ss");
    return data.format("DD/MM/YYYY");
  };

  const handleFormularioMenuOpen = (event, formulario) => {
    setFormularioSelecionado(formulario);
    setAnchorElement(event.currentTarget);
  };

  const handleMenuClose = () => {
    setFormularioSelecionado({});
    setAnchorElement(null);
  };

  const handlerMenuDuplicar = async () => {
    let formularioDuplicar = {
      nomeFormulario: "Duplicado " + formularioSelecionado.nomeFormulario,
      ativo: formularioSelecionado.ativo,
      campos: formularioSelecionado.campos.map((campo) => {
        return {
          id: 0,
          obrigatorio: campo.obrigatorio,
          nomeCampo: campo.nomeCampo,
          ordemCampo: campo.ordemCampo,
        };
      }),
    };

    history.push({
      pathname: `/formulario`,
      formularioDuplicar,
    });
  };

  const handlerMenuEditar = () => {
    console.log('formularioSelecionado -',formularioSelecionado)
    if(formularioSelecionado?.existeReuniaoVinculada){
      enqueueSnackbar("Este Formulário não pode ser editado, pois já está vinculado a uma reunião", {
        variant: "warning",
      });
    }else{
      history.push({
        pathname: `/formulario/${formularioSelecionado.id}/editar`,
      });
    }
  };

  const handleVisualizarFormulario = (event, formularioVisualizar) => {
    if (mostrarColunaMenuAcoes) {
      if (!event.target.attributes[0].nodeValue.includes("botaoAcoes")) {
        history.push({
          pathname: `/formulario/${formularioVisualizar.id}/visualizar`,
        });
      }
    }
  };

  const menuAcoes = () => {
    return (
      <Menu
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        {/* TODO: Igualar mensagem editar e excluir quando o formulário já tiver vinculado */}
        <MenuItem onClick={(event) => handlerMenuEditar(event)}>
          Editar
        </MenuItem>
        <MenuItem onClick={() => handlerMenuDuplicar()}>Duplicar</MenuItem>
        {TipoPerfil.EQUIPE_TECNICA.is(role) && (
          <>
            <hr style={{ border: "0.5px solid #dfdfe6" }} />
            <MenuItem onClick={() => setOpenExcluir(true)}>Excluir</MenuItem>
          </>
        )}
      </Menu>
    );
  };

  const limparFiltros = () => {
    setPaginacao(paginacaoInitialState);
    setOrdenacao(ordenacaoInitialState);

    let filtroLocal = { ...filtroInitialState };
    if (mostrarSomenteAtivos) {
      filtroLocal = { ...filtroInitialState, ativo: true };
      setFiltro(filtroLocal);
    } else {
      setFiltro(filtroLocal);
    }

    getRegistros(
      { ...paginacaoInitialState },
      { ...ordenacaoInitialState },
      { ...filtroLocal }
    );
    handleMenuClose();
  };

  const getRegistrosPaginacao = (page) => {
    getRegistros(
      { page: page, linesPerPage: paginacao.linesPerPage },
      ordenacao,
      filtro
    );
  };

  const getRegistros = async (paginacao, ordenacao, filtro) => {
    try {
      let localFilter = { ...filtro };
      if (filtro.ativo == " ") {
        delete localFilter.ativo;
      }

      const response = await getPage(
        { page: paginacao.page, linesPerPage: paginacao.linesPerPage },
        ordenacao,
        { ...localFilter }
      );

      setFormularios(response.data.content);
      setPaginacao({
        page: response.data.pageable.pageNumber,
        linesPerPage: response.data.pageable.pageSize,
        totalPages: response.data.totalPages,
      });

      const responseAll = await getAll();
      getFormularioDatas(responseAll.data);
    } catch (e) {
      console.log("error!!");
      console.log(e);
    }
  };

  const getFormularioDatas = (formularios) => {
    let datasFormularios = [];

    formularios.map((formulario) => {
      const data = moment(formulario.criacao, "YYYY-MM-DDTHH:mm:ss");
      const dataConvertida = data.format("MM-YYYY");
      const index = datasFormularios.findIndex(
        (object) => object.mesAno === dataConvertida
      );

      if (index === -1) {
        datasFormularios.push({ mesAno: dataConvertida });
      }
    });
    setFormularioDatas(datasFormularios);
  };

  const handleFormFiltroSubmit = async (event) => {
    event.preventDefault();

    getRegistros({ ...paginacao, page: 0 }, ordenacao, filtro);
  };

  const handleFormFiltroChange = (event) => {
    const { name, value } = event.target;

    if (name == "nomeFormulario" || name == "ativo") {
      setFiltro({ ...filtro, [name]: value });
    }

    if (name == "dataMesAno") {
      if (value == " ") {
        setFiltro({ ...filtro, dataInicio: " ", dataFim: " " });
      } else {
        const firstMonthDay =
          moment(value, "MM-YYYY").startOf("month").format("YYYY-MM-DD") +
          " 00:00:00";
        const lastMonthDay =
          moment(value, "MM-YYYY").endOf("month").format("YYYY-MM-DD") +
          " 23:59:59";

        setFiltro({
          ...filtro,
          dataInicio: firstMonthDay,
          dataFim: lastMonthDay,
        });
      }
    }

    if (name == "direction") {
      setOrdenacao({ ...ordenacao, [name]: value });
    }
  };

  const handleSelecionarFormulario = (formulario) => {
    onSetFormularioSelecionado({
      idFormulario: formulario.id,
      nomeFormulario: formulario.nomeFormulario,
    });
  };

  useEffect(() => {
    if (mostrarSomenteAtivos) {
      setFiltro({ ...filtro, ativo: true });
      getRegistros(paginacao, ordenacao, { ...filtro, ativo: true });
    } else {
      getRegistros(paginacao, ordenacao, filtro);
    }
  }, []);

  return (
    <>
      <form onSubmit={handleFormFiltroSubmit}>
        <div className={classes.barraFiltroDiv}>
          <div className={classes.barraFiltro}>
            <Grid container spacing={1}>
              <Grid item md={2} sm={12} xs={12}>
                <FormControl fullWidth>
                  <InputLabel shrink id="textNome">
                    Nome
                  </InputLabel>
                  <TextField
                    id="textNome"
                    fullWidth
                    name="nomeFormulario"
                    variant="outlined"
                    value={filtro.nomeFormulario}
                    placeholder="Digite sua busca"
                    onChange={handleFormFiltroChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon
                            style={{ color: "#0B4FD9", cursor: "pointer" }}
                          />
                        </InputAdornment>
                      ),
                      endAdornment: filtro.nomeFormulario ? (
                        <InputAdornment
                          onClick={() =>
                            setFiltro({ ...filtro, nomeFormulario: "" })
                          }
                          position="start"
                        >
                          <CloseIcon
                            style={{ color: "#5e6784", cursor: "pointer" }}
                          />
                        </InputAdornment>
                      ) : (
                        <></>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <FormControl fullWidth>
                  <InputLabel shrink id="selectOrdem">
                    Ordem Alfabética
                  </InputLabel>
                  <Select
                    id="selectOrdem"
                    name="direction"
                    value={ordenacao.direction}
                    onChange={handleFormFiltroChange}
                    fullWidth
                    variant="outlined"
                    IconComponent={ExpandMoreIcon}
                    displayEmpty
                  >
                    <MenuItem value="ASC">Ascendente</MenuItem>
                    <MenuItem value="DESC">Descendente</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <FormControl fullWidth>
                  <InputLabel shrink id="selectAtivo">
                    Ativos / Inativos
                  </InputLabel>
                  <Select
                    id="selectAtivo"
                    name="ativo"
                    value={filtro.ativo}
                    onChange={handleFormFiltroChange}
                    fullWidth
                    variant="outlined"
                    disabled={mostrarSomenteAtivos}
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem value=" ">Todos</MenuItem>
                    <MenuItem value="true">Ativos</MenuItem>
                    <MenuItem value="false">Inativos</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {formularioDatas.length > 0 && (
                <Grid item md={2} sm={4} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel shrink id="selectDataMesAno">
                      Mês/Ano
                    </InputLabel>
                    <Select
                      id="selectDataMesAno"
                      name="dataMesAno"
                      onChange={handleFormFiltroChange}
                      fullWidth
                      variant="outlined"
                      IconComponent={ExpandMoreIcon}
                      defaultValue=" "
                    >
                      <MenuItem value=" ">Todos</MenuItem>
                      {formularioDatas.map((formulario) => (
                        <MenuItem
                          key={formulario.mesAno}
                          value={formulario.mesAno}
                        >
                          {formulario.mesAno}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item md={2} sm={4} xs={6}>
                <Button type="submit" variant="contained">
                  Aplicar filtro
                </Button>
              </Grid>
              <Grid item md={2} sm={4} xs={6}>
                <Button onClick={() => limparFiltros()} variant="outlined">
                  Limpar filtros
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>

      <div id="conteudo" style={{ width: "100%" }}>
        <div style={{ padding: 20 }}>
          <div style={{ padding: 10 }}>
            <Grid
              container
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Grid item style={{ width: "60%" }}>
                <Typography className={tableClasses.cabecalho}>
                  Disponibilizados
                </Typography>
              </Grid>
              <Grid item style={{ width: "25%" }}>
                <Typography className={tableClasses.cabecalho}>
                  Data de criação
                </Typography>
              </Grid>
              <Grid item style={{ width: "15%" }}>
                {mostrarColunaMenuAcoes && (
                  <Typography className={tableClasses.cabecalho}>
                    Ações
                  </Typography>
                )}
                {mostrarColunaSelecionar && (
                  <Typography className={tableClasses.cabecalho}>
                    Selecionar Formulário
                  </Typography>
                )}
              </Grid>
            </Grid>
          </div>

          {formularios.length > 0 && (
            <div
              style={{
                background: "#fff",
                borderRadius: 6,
                border: "solid 1px #dfdfe6",
                color: "#5e6784",
              }}
            >
              <Grid
                container
                style={{ display: "flex", flexDirection: "column" }}
              >
                {formularios.map((formulario, index) => (
                  <Grid
                    key={index}
                    className={tableClasses.gridHover}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      borderBottom: "0.5px solid #dfdfe6",
                      borderRadius: "5px",
                      padding: "0px 10px",
                      justifyContent: "space-between",
                    }}
                    onClick={(event) =>
                      handleVisualizarFormulario(event, formulario)
                    }
                  >
                    <Grid
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        flexDirection: "column",
                        width: "60%",
                      }}
                    >
                      <Typography
                        className={tableClasses.bodyNome}
                        style={{ fontWeight: "bold" }}
                      >
                        {formulario.nomeFormulario}
                      </Typography>
                      <Typography className={tableClasses.bodyCriadoPor}>
                        Criado por: {formulario.nomeUsuarioCriacao}
                      </Typography>
                    </Grid>
                    <Grid
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        justifyContent: "center",
                        width: "25%",
                      }}
                    >
                      <Typography
                        className={tableClasses.bodyDataCriado}
                        style={{ fontWeight: "bold" }}
                      >
                        {formatDate(formulario.criacao)}
                      </Typography>
                      <Typography className={tableClasses.bodyDataEditado}>
                        Editado em {formatDate(formulario.ultimaAlteracao)}
                      </Typography>
                    </Grid>
                    <Grid
                      style={{
                        width: "15%",
                        display: "flex",
                        alignContent: "center",
                        flexDirection: "row",
                        padding: "10px 0px",
                      }}
                    >
                      {mostrarColunaMenuAcoes && (
                        <IconButton
                          onClick={(event) =>
                            handleFormularioMenuOpen(event, formulario)
                          }
                          style={{ zIndex: "1000" }}
                          className="botaoAcoes"
                        >
                          <MoreVertIcon className="botaoAcoes" />
                        </IconButton>
                      )}
                      {mostrarColunaSelecionar &&
                        (formulario.id ==
                        formularioVinculoSelecionado.idFormulario ? (
                          <Button
                            onClick={() =>
                              handleSelecionarFormulario(formulario)
                            }
                            variant="outlined"
                          >
                            <CheckOutlinedIcon
                              style={{
                                color: "#0B4FD9",
                                borderColor: "#0B4FD9",
                                cursor: "pointer",
                              }}
                            />{" "}
                            Selecionado
                          </Button>
                        ) : (
                          <Button
                            onClick={() =>
                              handleSelecionarFormulario(formulario)
                            }
                            style={{
                              color: "gray",
                              borderColor: "gray",
                              cursor: "pointer",
                            }}
                            variant="outlined"
                          >
                            Selecionar
                          </Button>
                        ))}
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              {menuAcoes()}
            </div>
          )}
        </div>

        {paginacao.totalPages > 1 && (
          <Pagination
            pagina={paginacao.page}
            tamanhoDaPagina={paginacao.linesPerPage}
            totalDePaginas={paginacao.totalPages}
            onChangePage={getRegistrosPaginacao}
          />
        )}
      </div>

      {openExcluir && (
        <ExcluirFormulario
          afterSubmit={limparFiltros}
          open={openExcluir}
          onClose={() => setOpenExcluir(false)}
          formulario={formularioSelecionado}
        />
      )}
    </>
  );
};

export default FormulariosList;
